import React, { FC } from "react";

interface RadioButtonProps {
  label: string;
  labelClassName?: string;
  radioClassName?: string;
  onChange?: any;
  name: string | boolean;
  value: string | undefined;
}

const RadioButton: FC<RadioButtonProps> = ({ label, labelClassName, onChange, name, value, radioClassName }) => {
  const radioTrue = (
    <div className={`w-4 h-4 md:w-5 md:h-5 rounded-full border-black border-[2px] flex items-center justify-center transition-all duration-300 ${radioClassName}`}>
      <div className="w-2 h-2 md:w-2.5 md:h-2.5 rounded-full bg-black transition-all duration-300"></div>
    </div>
  );

  const radioFalse = <div className={`w-4 h-4 md:w-5 md:h-5 rounded-full bg-white border-[1px] border-black flex items-center justify-center transition-all duration-300 ${radioClassName}`}></div>;

  return (
    <div className="flex items-center">
      <label className="relative inline-flex gap-2 items-center cursor-pointer" onClick={onChange}>
        {value === name ? radioTrue : radioFalse}
        <p className={`font-bold  text-[13px] md:text-sm ${labelClassName}`}>{label}</p>
      </label>
    </div>
  );
};

export default RadioButton;
